import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  SFPageContainer,
  SFCheckIcon,
  SFActionBar,
  ACTION_BAR_ACTION_NAMES,
  ACTION_BAR_ACTION_TYPES,
} from "@sf-core";
import { toastActions } from "@base-provider";
import { addExecutionFlow } from "../../../services/executionFlowService";
import { useTranslation } from "react-i18next";
import NewExecutionFlowForm from "./newExecutionFlowForm";
import { useDispatch } from "react-redux";
import { PATHS } from "../../../constants/paths";


const AddExecutionFlow = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    data: {
      executionFlowTypeId: "",
      comments: "",
    },
    errors: [],
  });

  const addExecutionFlowHandler = useCallback(async () => {
    if (form.errors.length > 0) {
      dispatch(
        toastActions.showErrorMessage(
          t("executionFlowsScreen.messages.formValidationError")
        )
      );
      return;
    }

    await addExecutionFlow(form.data);

    dispatch(
      toastActions.showSuccessMessage(
        t("executionFlowsScreen.messages.addSuccess")
      )
    );
    navigate(PATHS.ETLS);
  }, [form.errors]);

  const onFormChange = (data, errors) => {
    if (data?.executionFlowTypeId !== form.data?.executionFlowTypeId) {
      setForm((curState) => ({
        ...curState,
        data: { executionFlowTypeId: data.executionFlowTypeId, comments: "" },
        errors,
      }));
    } else {
      setForm({ data, errors });
    }
  };

  const leaveHandler = () => {
    navigate(PATHS.ADMIN_EXECUTION_FLOW_LANDING);
  };

  const actionDefs = [
    {
      name: ACTION_BAR_ACTION_NAMES.CANCEL,
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      onClick: () => leaveHandler(),
      buttonProps: {
        label: t("components.toolbar.templates.cancel"),
        variant: "secondary",
      },
    },
    {
      name: ACTION_BAR_ACTION_NAMES.ADD,
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      onClick: addExecutionFlowHandler,
      buttonProps: {
        label: t("executionFlowsScreen.newExecutionFlowScreen.addButton"),
        variant: "primary",
        icon: <SFCheckIcon size="small" />,
        async: true,
      },
      confirmation: true,
      confirmationProps: {
        header: t(
          "executionFlowsScreen.newExecutionFlowScreen.addConfirmationModalHeader"
        ),
        message: t(
          "executionFlowsScreen.newExecutionFlowScreen.addConfirmationModalMessage"
        ),
      },
    },
  ];

  return (
    <SFPageContainer>
      <SFActionBar
        actionDefs={actionDefs}
        titleProps={{
          title: t("etlRoutes.addExecutionFlow"),
        }}
      />
      <NewExecutionFlowForm data={form.data} onChange={onFormChange} />
    </SFPageContainer>
  );
};

export default AddExecutionFlow;
